'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

/**
 * Full list: https://en.wikipedia.org/wiki/Date_format_by_country
 * Canada specific: https://en.wikipedia.org/wiki/Date_and_time_notation_in_Canada
 * South Africa specific: https://en.wikipedia.org/wiki/Date_and_time_notation_in_South_Africa
 */ exports.DateInputFormats = void 0;
(function(DateInputFormats) {
    DateInputFormats["DMY"] = 'dd/MM/yyyy';
    DateInputFormats["MDY"] = 'M/d/yyyy';
    DateInputFormats["YMD"] = 'yyyy/MM/dd';
})(exports.DateInputFormats || (exports.DateInputFormats = {}));
exports.DateInputPlaceholders = void 0;
(function(DateInputPlaceholders) {
    DateInputPlaceholders["DMY"] = 'dd/mm/yyyy';
    DateInputPlaceholders["MDY"] = 'mm/dd/yyyy';
    DateInputPlaceholders["YMD"] = 'yyyy/mm/dd';
})(exports.DateInputPlaceholders || (exports.DateInputPlaceholders = {}));
exports.DateInputParsings = void 0;
(function(DateInputParsings) {
    DateInputParsings["DMY"] = 'dd/MM/yyyy';
    DateInputParsings["MDY"] = 'MM/dd/yyyy';
    DateInputParsings["YMD"] = 'yyyy/MM/dd';
})(exports.DateInputParsings || (exports.DateInputParsings = {}));
exports.DatePickerPlacements = void 0;
(function(DatePickerPlacements) {
    DatePickerPlacements["BottomEnd"] = 'bottom-end';
    DatePickerPlacements["BottomStart"] = 'bottom-start';
    DatePickerPlacements["RightStart"] = 'right-start';
    DatePickerPlacements["TopEnd"] = 'top-end';
    DatePickerPlacements["TopStart"] = 'top-start';
})(exports.DatePickerPlacements || (exports.DatePickerPlacements = {}));
//# sourceMappingURL=date.js.map
